import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Document, pdfjs, Page } from 'react-pdf';
import { useCallback } from 'react';
import { Box, ButtonGroup, Button, Typography } from '@mui/material';
import { NavigateNext, NavigateBefore } from '@mui/icons-material';
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString();
/**
 * Pdf file viewer, with pagination
 */
const PdfViewer = ({ pdfFileSource, onPdfLoadedSuccessfully = () => { }, numberOfPdfPages, setNumberOfPdfPages, nextPageClick, previousPageClick, pageNumber, setInitialPage, showNavigation = true, showPageNumberCounter = true, pageHeight, pageWidth, onRootElementClick = () => { }, setCurrentPdfDimensions = () => { }, pdfPageParentDivSx, }) => {
    const onLoadSuccess = useCallback((pdf) => {
        const { numPages } = pdf;
        setNumberOfPdfPages(numPages);
        setInitialPage();
        onPdfLoadedSuccessfully();
    }, [onPdfLoadedSuccessfully, setInitialPage, setNumberOfPdfPages]);
    return (_jsxs(Box, { sx: { position: 'relative', display: 'flex', justifyContent: 'center' }, onClick: (e) => {
            onRootElementClick(e);
            setInitialPage();
        }, children: [_jsx(Box, { sx: Object.assign(Object.assign({}, pdfPageParentDivSx), { overflow: 'hidden' }), children: _jsx(Document, { file: pdfFileSource, onLoadSuccess: onLoadSuccess, children: _jsx(Page, { onLoadSuccess: (pdf) => {
                            const width = pdf.view[2];
                            const height = pdf.view[3];
                            setCurrentPdfDimensions({ height, width });
                        }, pageNumber: pageNumber, height: pageHeight, width: pageWidth }) }) }), ((showNavigation && numberOfPdfPages > 1) || showPageNumberCounter) && (_jsxs(ButtonGroup, { variant: 'outlined', size: 'large', sx: {
                    boxShadow: 2,
                    zIndex: 1,
                    backgroundColor: 'white',
                    position: 'absolute',
                    bottom: '2%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }, onClick: (e) => {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                }, children: [showNavigation && (_jsx(Button, { disabled: pageNumber === 1, sx: { pr: 0, borderColor: 'rgba(0, 0, 0, 0.12) !important' }, onClick: previousPageClick, startIcon: _jsx(NavigateBefore, {}) })), showPageNumberCounter && (_jsx(Box, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            px: 1,
                            borderTop: `1px solid rgba(0, 0, 0, 0.12)`,
                            borderBottom: `1px solid rgba(0, 0, 0, 0.12)`,
                            minWidth: '50px',
                        }, children: _jsx(Typography, { children: `${pageNumber}/${numberOfPdfPages}` }) })), showNavigation && (_jsx(Button, { disabled: pageNumber >= numberOfPdfPages, sx: { pl: 0, borderColor: 'rgba(0, 0, 0, 0.12) !important' }, onClick: nextPageClick, endIcon: _jsx(NavigateNext, {}) }))] }))] }));
};
export default PdfViewer;
